import withResponsive from '../hoc/withResponsive'
import Swiper from 'swiper/dist/js/swiper.min.js'

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default withResponsive({
  name: 'image-gallery',

  componentDidMount () {
    setTimeout(() => {
      this.swiper = new Swiper(this.el.querySelector('.swiper-container'), {
        // Optional parameters
        direction: 'horizontal',
        speed: 600,
        // initialSlide: self.el.querySelectorAll('.swiper-slide').length - 3, // 3 car slide-duplicate-...
        // reverseDirection: true,
        loop: false,
        // loopedSlides: 5,
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-img-gallery-button-next',
          prevEl: '.swiper-img-gallery-button-prev',
        },
        pagination: {
          el: '.swiper-img-gallery-pagination',
          type: 'bullets',
          bulletElement: 'li',
        },
        slidesPerView: 'auto',
        spaceBetween: 20,
        // slidesOffsetBefore: 0,

        /*  autoplay: {
          delay: 1000,
          disableOnInteraction: true,
        }, */

        /* on: {
          slideChangeTransitionEnd: function () {
            that.updateCounter(this.realIndex)
            that.animate(true)
          },

          slideChangeTransitionStart: function () {
            that.animate(false)
          }
        },, */
        // breakpointsInverse: true,
        breakpoints: {
          // when window width is >= 768px
          769: {
            slidesPerView: 'auto',
            spaceBetween: 40,
          },
        },
      })
    }, 2000)
  },
})
